import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getLocationApi = async (term) => {
  try {
    const response = await axios.get(apiAdminUrl + `get_location?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVehicleTypeApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + `vehicletype/autosuggestion?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getDockApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + `dockmaster/autosuggestion?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getStatusApi = async (term) => {
  try {
    const response = await axios.get(apiAdminUrl + `get_location?term=` + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const exportdata = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `dock/report`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const downloadBase64File = (base64String, fileName) => {
  const binary = atob(base64String);
  const array = [];

  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }

  const blob = new Blob([new Uint8Array(array)], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



export const exportquickApi = async (apivalue,formattedFromDate,formattedToDate) => {
  try {
    const response = await axios
    .post(
          apiUrl + "report/" + apivalue,
          {
            from_date: formattedFromDate,
            to_date: formattedToDate,
          },
          {
            headers: header
          }
        )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getquickreportApi = async () => {
  try {
    const response = await axios.get(apiUrl + `report/get_quick_report`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};




//templates & exports

export const savetempalteApi = async (data) => {
    try {
        const response = await axios.post(
            apiAdminUrl + `export_template`, data, { headers: header }).then((response) => {
                return response;
            }).catch((error) => {
                console.log('error...', error.response)
                return error.response;

            });
        return response;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};


export const getExportfieldApis = async (id) => {
    try {
        const response = await axios.get(
            apiAdminUrl + `export_template/` + id,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};

export const getDownloadReportApi = async () => {
    try {
        const response = await axios.get(
            apiAdminUrl + `downloaded_reports?type=Dock`,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};

export const getExportdownloadApis = async (id) => {
    try {
        const response = await axios.get(
            apiAdminUrl + `downloaded_reports/` + id,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};

export const getTempalteApi = async () => {
    try {
        const response = await axios.get(
            apiAdminUrl + `export_template?application=Dock`,
            {
                headers: header,
            }
        );
        return response.data;
    } catch (err) {
        console.error("Error fetching category:", err);
    } finally {
    }
};

